module.exports = __webpack_public_path__ + "img/sceneBack2.fd279d83.png";